// extracted by mini-css-extract-plugin
module.exports = {"blockMTSSpinner":"mts-spinner_blockMTSSpinner__10l9x","spinnerIcon":"mts-spinner_spinnerIcon__3Fret","spin":"mts-spinner_spin__3QdHO"};